import { useState, useEffect, useRef } from 'react'
import '../styles/WhatsApp.css'

const makeURL = (num, msg) =>
  `https://wa.me/${num}?text=${encodeURIComponent(msg)}`

const MSG = 'Hello! I came across your website and I am interested in your trophy and award products. Could you please share more details?'

const NUMBERS = [
  { label: 'Khetan Singh', number: '919840538852', url: makeURL('919840538852', MSG) },
  { label: 'Hitesh', number: '919940334044', url: makeURL('919940334044', MSG) },

]

export default function WhatsApp() {
  const [visible,  setVisible]  = useState(false)
  const [open,     setOpen]     = useState(false)
  const [pulse,    setPulse]    = useState(false)
  const ref = useRef(null)

  useEffect(() => {
    const t1 = setTimeout(() => setVisible(true), 2000)
    const interval = setInterval(() => {
      if (!open) {
        setPulse(true)
        setTimeout(() => setPulse(false), 1200)
      }
    }, 10000)
    return () => { clearTimeout(t1); clearInterval(interval) }
  }, [open])

  // Close picker when clicking outside
  useEffect(() => {
    const handler = e => { if (ref.current && !ref.current.contains(e.target)) setOpen(false) }
    document.addEventListener('mousedown', handler)
    return () => document.removeEventListener('mousedown', handler)
  }, [])

  return (
    <div ref={ref} className={`wa-wrapper ${visible ? 'wa-visible' : ''}`}>

      {/* Number picker panel */}
      <div className={`wa-picker ${open ? 'wa-picker--open' : ''}`}>
        <div className="wa-picker-header">
          <span className="wa-picker-ico">💬</span>
          <div>
            <div className="wa-picker-title">Chat on WhatsApp</div>
            <div className="wa-picker-sub">Choose a number to connect</div>
          </div>
        </div>
        <div className="wa-picker-list">
          {NUMBERS.map((n, i) => (
            <a
              key={i}
              href={n.url}
              target="_blank"
              rel="noopener noreferrer"
              className="wa-number-row"
              onClick={() => setOpen(false)}
            >
              <div className="wa-num-avatar">
                <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" width="22" height="22">
                  <path d="M16 2C8.268 2 2 8.268 2 16c0 2.482.65 4.81 1.787 6.83L2 30l7.363-1.763A13.935 13.935 0 0016 30c7.732 0 14-6.268 14-14S23.732 2 16 2z" fill="#25D366"/>
                  <path d="M22.555 19.615c-.315-.157-1.862-.918-2.15-1.022-.287-.105-.496-.157-.705.157-.21.315-.81 1.022-.993 1.232-.183.21-.367.236-.682.079-.315-.158-1.33-.49-2.532-1.56-.936-.833-1.568-1.861-1.752-2.176-.183-.315-.02-.485.138-.642.14-.14.315-.366.472-.55.158-.183.21-.314.315-.524.105-.21.053-.394-.026-.55-.079-.158-.705-1.7-.966-2.328-.254-.612-.513-.529-.705-.538l-.6-.01c-.21 0-.55.079-.838.394-.288.315-1.1 1.075-1.1 2.62 0 1.547 1.126 3.043 1.283 3.252.158.21 2.216 3.384 5.37 4.745.75.324 1.336.517 1.791.662.752.239 1.437.205 1.978.124.604-.09 1.862-.761 2.124-1.496.263-.735.263-1.365.184-1.496-.079-.13-.288-.21-.603-.367z" fill="#fff"/>
                </svg>
              </div>
              <div className="wa-num-info">
                <span className="wa-num-label">{n.label}</span>
                <span className="wa-num-digits">+{n.number.replace(/^91/, '91 ')}</span>
              </div>
              <span className="wa-num-arrow">→</span>
            </a>
          ))}
        </div>
      </div>

      {/* Main button */}
      <button
        className={`wa-btn ${pulse ? 'wa-pulse' : ''} ${open ? 'wa-btn--open' : ''}`}
        aria-label="Chat on WhatsApp"
        onClick={() => setOpen(p => !p)}
      >
        {/* WhatsApp icon */}
        <svg className="wa-icon wa-icon-main" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M16 2C8.268 2 2 8.268 2 16c0 2.482.65 4.81 1.787 6.83L2 30l7.363-1.763A13.935 13.935 0 0016 30c7.732 0 14-6.268 14-14S23.732 2 16 2z" fill="#fff"/>
          <path d="M22.555 19.615c-.315-.157-1.862-.918-2.15-1.022-.287-.105-.496-.157-.705.157-.21.315-.81 1.022-.993 1.232-.183.21-.367.236-.682.079-.315-.158-1.33-.49-2.532-1.56-.936-.833-1.568-1.861-1.752-2.176-.183-.315-.02-.485.138-.642.14-.14.315-.366.472-.55.158-.183.21-.314.315-.524.105-.21.053-.394-.026-.55-.079-.158-.705-1.7-.966-2.328-.254-.612-.513-.529-.705-.538l-.6-.01c-.21 0-.55.079-.838.394-.288.315-1.1 1.075-1.1 2.62 0 1.547 1.126 3.043 1.283 3.252.158.21 2.216 3.384 5.37 4.745.75.324 1.336.517 1.791.662.752.239 1.437.205 1.978.124.604-.09 1.862-.761 2.124-1.496.263-.735.263-1.365.184-1.496-.079-.13-.288-.21-.603-.367z" fill="#25D366"/>
        </svg>

        {/* Close X when open */}
        <svg className="wa-icon wa-icon-close" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5" strokeLinecap="round">
          <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
        </svg>

        {/* Ping rings */}
        <span className="wa-ring wa-ring-1" />
        <span className="wa-ring wa-ring-2" />
      </button>

      {/* Label badge */}
      <div className="wa-label">{open ? 'Close' : 'WhatsApp'}</div>
    </div>
  )
}